export default __webpack_public_path__ + "static/media/hinge7.04156572.jpg";